import { compact, zipObject, chain, isEqual, flatten, groupBy, values, get } from 'lodash'
import Ajax from 'superagent'
import memoize from 'memoizerific'
import { getLanguage } from '../lib/text'

export function getSelection(agenda, selected) {
  /* extract the selected items; we only have info about selected *days*, and need
   * the items contained therein */
  const selection = []
  let on = false
  agenda.forEach(item => {
    if (item.type == "day") {
      on = selected[item.key]
    }
    if (on) {
      selection.push(item)
    }
  })

  /* if any item in this selection is a reference to another (repeated expenses),
   * only include the referenced in the selection
   * @TODO check if I'm replacing all references, and dangerously losing info about repetitions */
  for (let i = 0; i < selection.length; i++) {
    if (selection[i].ref && !selection.find(item => item.key == selection[i].ref)) {
      selection[i] = agenda.find(item => item.key == selection[i].ref)
    }
  }

  return selection
}

function _getUniqExpenses(agenda) {
  // #TODO refactor this, but with care. just filter and map!
  const exs = compact(
    agenda.map((x, i) => (
      (!x.ref && x.type == "expense")
        ? ({ expense: x.expense, counter: 0, index: i, key: x.key })
        : null
    ))
  )

  return zipObject(exs.map(x => x.key), exs)
}

function _getPriceValuePerItem(bill) {
  return chain(bill)
    .flatMap("items")
    .filter("priceValue")
    .keyBy("key")
    .mapValues(item => item.priceValue)
    .value()
}

export const getPriceValuePerItem = memoize(2)(_getPriceValuePerItem)
export const getUniqExpenses = memoize(2)(_getUniqExpenses)

const transportTrad = {
  train: "RAIL",
  airplane: "airplane",
  bus: 'BUS'
}

function findNextHotel(array, n) {
  const item = array[n]
  if (item.type == "expense" && ((item.expense && item.expense.type == "hotel") || item.ref)) return item
  else return findNextHotel(array, n + 1)
}

function _getGoogleRoute(route, Cities, Activities) {
  let daysCounter = 0
  let lastHotel = {}
  return compact(flatten(route.map((item, i, arr) => {
    const array = []
    if (item.type == "city" && item.transport) {
      const transportType = item.transport.means
      if (
        i != 0 && item.transport.originCity 
        && (
          Cities[item.transport.originCity].stations[item.transport.departureStationKey] 
          || item.transport.departureStationCustom
        )
      ) {
        array.push({
          ...item,
          i,
          name: item.transport.departureStationCustom || Cities[item.transport.originCity].stations[item.transport.departureStationKey].address,
          daysCounter,
          recommendedTransportation: (item.transport.commuteTo && item.transport.commuteTo.recommendedTransportation) || "PUBLIC_TPT",
          transportType: transportTrad[transportType],
          preciseLocation: Cities[item.transport.originCity].stations[item.transport.departureStationKey]
            && Cities[item.transport.originCity].stations[item.transport.departureStationKey].preciseLocation,
          city : Cities[item.transport.originCity].name
        })
      }
      if (
        i != arr.length - 1 && item.transport.to 
        && (
          Cities[item.transport.to].stations[item.transport.arrivalStationKey] 
          || item.transport.arrivalStationCustom
        )
      ) {
        array.push({
          ...item,
          i,
          name: item.transport.arrivalStationCustom || Cities[item.transport.to].stations[item.transport.arrivalStationKey].address,
          daysCounter,
          recommendedTransportation: transportType == "train" ? "PUBLIC_TPT" : "DRIVE",
          transportType: transportTrad[transportType],
          preciseLocation: Cities[item.transport.to].stations[item.transport.arrivalStationKey]
            && Cities[item.transport.to].stations[item.transport.arrivalStationKey].preciseLocation,
          city : Cities[item.transport.to].name
        })
        if (item.transport.shouldGoToHotelFirst) {
          const hotel = findNextHotel(arr, i + 1) /* find(arr, { type: "expense", expense: { type: "hotel" }}, i) || find(arr, (x) => x.type == "expense" && x.ref, i) */
          if (hotel.ref) {
            const refExpense = route.filter(z => z.key == hotel.ref)[0]
            array.push({ 
              ...hotel, 
              virtualNextHotel: true,
              i,
              daysCounter, 
              ...refExpense, 
              recommendedTransportation: hotel.recommendedTransportation, 
              preciseLocation : refExpense.expense.preciseLocation, 
              name : refExpense.expense.name  
            })
          } 
          else {
            array.push({ 
              ...hotel, 
              virtualNextHotel: true,
              isHotel: true,
              i,
              daysCounter, 
              recommendedTransportation: (item.transport.commuteFrom && item.transport.commuteFrom.recommendedTransportation) || "DRIVE",
              preciseLocation : hotel.expense.preciseLocation, 
              name : hotel.expense.name
            })
          }
        }
      }
      return array
    }
    else if (item.type == "expense" && item.ref) {
      const refExpense = route.filter(z => z.key == item.ref)[0]
      lastHotel = { 
        ...item, 
        i,
        daysCounter, 
        ...refExpense, 
        recommendedTransportation: item.recommendedTransportation, 
        preciseLocation : refExpense.expense.preciseLocation, 
        name : refExpense.expense.name,
        isHotel: true,
      }
      return lastHotel
    }
    else if (item.type == "expense" && item.expense && item.expense.type == "hotel") {
      lastHotel = { 
        ...item, 
        i,
        daysCounter, 
        preciseLocation : item.expense.preciseLocation, 
        name : item.expense.name,
        isHotel: true,
      }
      return lastHotel
    }
    else if (item.type == "day") {
      array.push({ 
        ...item, 
        i,
        daysCounter: item.type == "day" ? ++daysCounter : daysCounter })
      if (route[i + 1] && route[i + 1].type == "activity") array.push({ ...lastHotel, daysCounter })
      return array
    }
    else if (item.type == "activity") {
      const activity = Activities[item.id]
      return { 
        ...item, 
        i,
        daysCounter, 
        preciseLocation: activity.preciseLocation, 
        name : activity.name,
        city : activity.city 
      }
    }
    else return ""
  }))).filter(x => x.type == "city" || x.type == "activity" || (x.type == "expense" && x.expense && x.expense.type == "hotel" && x.preciseLocation && x.preciseLocation.latitude && x.preciseLocation.longitude))
}

export const getGoogleRoute = memoize(2)(_getGoogleRoute)

function _getApiRoute(itemLocation, nextItemLocation, language, mode, transitMode) {
  return Ajax
    .get(`/private/getdirection`)
    .query({ itemLocation, nextItemLocation, language, mode, transitMode })
}
const getApiRoute = memoize(3000)(_getApiRoute)

const travelModes = {
  PUBLIC_TPT: "transit",
  TRANSIT: "transit",
  WALKING: "walking",
  DRIVE: "driving",
  CABIFY: "driving",
  GUIDE: "driving",
  OTHER: "driving",
} 

function getPlaceI(item, nextItem, nextnextItem) {
  if(nextItem.virtualNextHotel) return item.i
  else if(item.type=='city' && nextItem.type=='city') return nextnextItem.i - 1
  else return nextItem.i - 1
}

function _getTimeRoute(googleRoute) {
  const routeForTimes = groupBy(googleRoute, 'daysCounter')

  return Promise.all(values(routeForTimes).map(async day => {
    return  Promise.all(day.map((item, i) => {
      return new Promise(async (resolve) => {
        const nextItem = day[i + 1]
        const nextnextItem = day[i + 2]
        if (nextItem) {
          if(item.type == 'city' && nextItem.type == 'city' && item.transportType == 'airplane') resolve()
          else {
            const itemLocation = item.preciseLocation && item.preciseLocation.latitude && item.preciseLocation.longitude ? `${item.preciseLocation.latitude},${item.preciseLocation.longitude}` : item.name
            const nextItemLocation = nextItem.preciseLocation && nextItem.preciseLocation.latitude && nextItem.preciseLocation.longitude ? `${nextItem.preciseLocation.latitude},${nextItem.preciseLocation.longitude}` : nextItem.name
            const recommendedTransportation = travelModes[nextItem.recommendedTransportation || "WALKING"]
            const data = await getApiRoute(itemLocation, nextItemLocation, getLanguage(), recommendedTransportation, item.transportType && item.transportType.toLowerCase())
            resolve({
              itemi: item.i,
              nextItemi: nextItem.i,
              placei: getPlaceI(item, nextItem, nextnextItem), 
              recommendedTransportation,
              transportType: item.type == 'city' && nextItem.type=='city' && item.transportType,
              toStation: item.type != 'city' && nextItem.type=='city' && nextItem.transportType,
              fromStation: item.type == 'city' && nextItem.type!='city' && item.transportType,
              toHotel: nextItem.virtualNextHotel,
              fromHotel: item.isHotel,
              distance: get(data, 'body.routes[0].legs[0].distance.text', '¯\\_(ツ)_/¯'), 
              duration: get(data, 'body.routes[0].legs[0].duration.text', '¯\\_(ツ)_/¯'),
              durationTime: get(data, 'body.routes[0].legs[0].duration.value', '¯\\_(ツ)_/¯'),
            })
          }
        }
        else resolve()
        })
    }))
  }))
}

export const getTimeRoute = memoize(2)(_getTimeRoute)